/** @format */

import { iccidConstants } from './actions';
import { reducerDebug } from '../../core/debug';

export function iccidReducers(state = {}, action) {
    reducerDebug('Iccid reducer: ' + action.type);
    switch (action.type) {
        case iccidConstants.LIST_ICCID_POOL:
        case iccidConstants.LIST_ICCID_POOL_SERIAL:
        case iccidConstants.LIST_ICCID_POOL_NAME_SELECT:
        case iccidConstants.LIST_ICCID_POOL_SERIAL_CHOOSE:
            return {
                type: action.type,
                collections: action.collections,
            };
        case iccidConstants.LIST_ICCID_POOL_ITEM_LIST:
        case iccidConstants.LIST_ICCID_POOL_ITEM:
        case iccidConstants.LIST_ICCID_POOL_EDIT:
            return {
                type: action.type,
                item: action.item,
            };
        case iccidConstants.LIST_ICCID_POOL_ADD_NEW:
        case iccidConstants.LIST_ICCID_POOL_EDIT_SAVE:
            return {
                type: action.type,
                success: true,
            };
        case iccidConstants.LIST_ICCID_POOL_DELETE:
            return {
                type: action.type,
                success: false,
                rows: null,
            };
        case iccidConstants.LIST_ICCID_POOL_GET_INDICATED_RANGE:
        case iccidConstants.LIST_ICCID_POOL_GET_INDICATED_RANGE_DISCOUNT_TEMPLATES:
            return {
                type: action.type,
                indicatedRanges: action.collections,
            };
        case iccidConstants.LIST_ICCID_POOL_GET_TARIFFS:
            return {
                type: action.type,
                tariffs: action.collections,
            };
        case iccidConstants.ICCID_POOL_PLATFORM_RESELLERS:
            return {
                type: action.type,
                platformResellers: action.collections,
            };
        default:
            return {
                ...state,
                type: action.type,
            };
    }
}
